export default "__VITE_ASSET__B2pNu1Ht__"